import { FETCH_ITEM_TYPES } from "actions";

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ITEM_TYPES:
      return action.payload || {};
    default:
      return state;
  }
}
